var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCheckout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    id: "checkout",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60948,0.781049c0.781049,0.781049 0.781049,2.04738 0,2.82843c-0.781049,0.781049 -2.04738,0.781049 -2.82843,0c-0.781049,-0.781049 -0.781049,-2.04738 0,-2.82843c0.781049,-0.781049 2.04738,-0.781049 2.82843,0",
    transform: "translate(9.805 11.805)",
    fill: "#feffff",
    className: "color000000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60948,0.781049c0.781049,0.781049 0.781049,2.04738 0,2.82843c-0.781049,0.781049 -2.04738,0.781049 -2.82843,0c-0.781049,-0.781049 -0.781049,-2.04738 -8.88178e-16,-2.82843c0.781049,-0.781049 2.04738,-0.781049 2.82843,0",
    transform: "translate(3.805 11.805)",
    fill: "#feffff",
    className: "color000000 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7983,2.39795c-0.188965,-0.250488 -0.484375,-0.397949 -0.79834,-0.397949h-3v2h1.67432l-1.42871,5h-7.39844l-1.36084,-8.16455c-0.0800781,-0.481934 -0.497559,-0.835449 -0.986328,-0.835449h-2.5v2h1.65283l1.36084,8.16455c0.080078,0.481934 0.497558,0.835449 0.986328,0.835449h9c0.446289,0 0.838867,-0.295898 0.961426,-0.725098l2,-7c0.086426,-0.301758 0.0258791,-0.626465 -0.163086,-0.876953Z",
    fill: "#feffff",
    className: "color000000 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5,1.45703l-1.45703,-1.45703l-2.5,2.5l-1.04297,-1.04297l-1.5,1.5l2.5,2.5Z",
    transform: "translate(5 .043)",
    fill: "#feffff",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckout);
export default __webpack_public_path__ + "static/media/Icon - checkout.842182452742a45ea7fdf82ad6756b6d.svg";
export { ForwardRef as ReactComponent };